<template>
  <div>
    <b-card>
      <div v-if="loading">
        <b-spinner
          variant="primary"
          style="width: 3rem; height: 3rem"
          label="Large Spinner"
        ></b-spinner>
      </div>

      <div class="row" v-if="!loading">
        <div class="col">
          <h4>{{ contact.name }}</h4>
        </div>
        <div class="col-auto text-right">
          <a
            v-b-tooltip.hover
            title="Print"
            :href="
              '/pdf/reports/contact/' + id + '/report?cid=' + contact.company_id
            "
            class="btn btn-primary mr-1"
            target="_blank"
          >
            <i class="lni lni-printer mr-0"></i>
          </a>

          <router-link
            v-b-tooltip.hover
            title="account"
            :to="{
              name: 'accounts-account',
              params: { id: contact.account ? contact.account.id : '' },
            }"
            class="btn btn-secondary mr-1"
          >
            <i class="lni lni-calculator"></i> Account
          </router-link>

          <router-link
            v-b-tooltip.hover
            title="Edit"
            :to="{
              name: 'contacts-edit',
              params: { id: contact.id },
            }"
            class="btn btn-info mr-1"
          >
            <i class="lni lni-pencil mr-0"></i>
          </router-link>

          <span
            v-b-tooltip.hover
            style="cursor: pointer"
            title="Delete"
            @click="confirmDelete(contact.id)"
            class="btn btn-danger"
          >
            <i class="lni lni-trash mr-0"></i>
          </span>
        </div>
      </div>

      <b-row v-if="!loading" class="mt-2">
        <b-col>
          <b-tabs v-model="tabIndex">
            <b-tab title="Details">
              <table class="table">
                <table-row
                  label="Name"
                  :copyText="contact.name"
                  :noBorder="true"
                >
                  {{ contact.name }}
                </table-row>

                <table-row label="Category">
                  {{ contact.category }}
                </table-row>

            

                <table-row
                  label="Contact Number"
                  :copyText="contact.contact_number"
                >
                  {{ contact.contact_number }}
                </table-row>

                <table-row label="Contact Number 2">
                  {{ contact.contact_number_2 }}
                </table-row>

                <table-row label="Email" :copyText="contact.email_address">
                  {{ contact.email_address }}
                </table-row>

                <table-row label="Website">
                  {{ contact.website }}
                </table-row>



                <table-row
                  label="Address"
                  class="nl2br"
                  :copyText="contact.address"
                >
                  {{ contact.address }}
                </table-row>

                <table-row label="City" :copyText="contact.city">
                  {{ contact.city }}
                </table-row>

                <table-row label="Province">
                  {{ contact.province }}
                </table-row>

                <table-row label="Country">
                  {{ contact.country }}
                </table-row>

                <table-row label="Vat #">
                  {{ contact.vat_number }}
                </table-row>

                <table-row label="Registration #">
                  {{ contact.registration_number }}
                </table-row>

                <table-row label="Notes" class="nl2br">
                  {{ contact.notes }}
                </table-row>

                <table-row icon="lni-database" :noBorder="true" />

                <table-row label="Id">
                  {{ contact.id }}
                </table-row>

                <table-row label="Created">
                  {{
                    moment(new Date(contact.created_at)).format(
                      "DD MMM YYYY, HH:mm:ss"
                    )
                  }}
                </table-row>
                <table-row label="Updated">
                  {{
                    moment(new Date(contact.updated_at)).format(
                      "DD MMM YYYY, HH:mm:ss"
                    )
                  }}
                </table-row>
              </table>
            </b-tab>

            <b-tab title="Files" class="pt-3">
              <b-skeleton-img v-if="FileLoading"></b-skeleton-img>

              <div></div>

              <table class="table">
                <tr v-for="file in contact.contact_files" :key="file.id">
                  <td>
                    <a :href="file.url" target="new">
                      {{ file.description }}<br />
                    </a>
                  </td>
                  <td>{{ file.size / 1024 }}kb</td>
                  <td class="text-right text-muted">
                    {{
                      moment(new Date(file.created_at)).format(
                        "DD MMM YYYY, HH:mm:ss"
                      )
                    }}
                  </td>
                  <td class="text-right">
                    <i
                      class="lni lni-trash text-danger pointer table-action-icon"
                      @click="fileDeleteConfirm(file.id)"
                    ></i>
                  </td>
                </tr>
              </table>

              <div class="p-3 my-2 bg-light">
                <form-group label="Add Files">
                  <file-upload
                    :key="fileComponentKey"
                    @files-uploaded="
                      selectedContactFiles = $event;
                      fileUploading = false;
                    "
                    @files-uploaded-started="fileUploading = true"
                    :multiple="true"
                  />
                  <small class="text-muted font-size-11"
                    >*Max file size is 16MB</small
                  >
                </form-group>

                <b-button
                  class="float-right"
                  @click="saveFiles"
                  variant="primary"
                  size="sm"
                  v-if="selectedContactFiles.length > 0"
                  >Save Files</b-button
                >

                <div style="clear: both"></div>
              </div>
            </b-tab>

            <b-tab class="pt-3" title="Images">
              <b-skeleton-img v-if="ImageLoading"></b-skeleton-img>

              <v-lazy-image
                @intersect="ImageLoading = true"
                @load="ImageLoading = false"
                v-if="selectedImage != null"
                :src="selectedImage"
                class="img-fluid border"
              />
              <div></div>

              <div
                class="border d-inline-block p-1 m-1"
                v-for="image in contact.contact_images"
                :key="image.id"
              >
                <a href="#" @click="selectedImage = image.large">
                  <v-lazy-image :src="image.small" class="maxHeight100" />
                </a>
                <i
                  class="lni lni-trash text-danger pointer table-action-icon position-absolute ml-n4"
                  @click="imageDeleteConfirm(image.id, contact.id)"
                ></i>
              </div>

              <div v-if="loading">
                <b-spinner
                  variant="primary"
                  style="width: 1rem; height: 1rem"
                  label="Large Spinner"
                ></b-spinner>
              </div>

              <div class="bg-light p-3 my-2">
                <form-group label="Add Images">
                  <image-upload
                    :key="imageComponentKey"
                    @files-uploaded="
                      selectedImages = $event;
                      imageUploading = false;
                    "
                    @files-uploaded-started="imageUploading = true"
                    :multiple="true"
                    :imageCrop="false"
                    acceptedTypes="image/*"
                  />
                  <small class="text-muted font-size-11"
                    >*Max file size is 16MB</small
                  >
                </form-group>
                <b-button
                  class="float-right"
                  @click="saveImages"
                  variant="primary"
                  size="sm"
                  v-if="selectedImages.length > 0"
                  >Save Images</b-button
                >
                <div style="clear: both"></div>
              </div>
            </b-tab>

          

            <b-tab title="Expenses (Paid)">
              <table class="table table-borderd mt-3">
                <tr class="bg-dark text-white">
                  <td>Date</td>
                   <td>Property</td>
                   <td>Item</td>
                   <td>Amount</td>
                </tr>
                <tr v-for="expense in contact.expenses" :key="expense.id">
                  <td>
                    {{
                      moment(new Date(expense.expense_date)).format("DD MMM YY")
                    }}
                  </td>

                  <td>
                    <router-link
                      :to="{
                        name: 'properties-show',
                        params: { id: expense.property.id },
                      }"
                    >
                      {{ expense.property.title }}
                    </router-link>
                  </td>

                  <td>
                    {{ expense.item }}
                  </td>
                  <td>
                    {{ expense.amount }}
                  </td>
                </tr>
              </table>

              <b-alert variant="info" show>
                <b-media>
                  <template #aside>
                    <i class="lni lni-bulb font-size-26"></i>
                  </template>
                  <ul>
                    <li>
                      Tip: Contact expenses can be added in the property view
                      under the expenses tab.
                    </li>
                  </ul>
                </b-media>
              </b-alert>
            </b-tab>
          </b-tabs>
        </b-col>
      </b-row>
    </b-card>

    <b-modal
      :hide-footer="true"
      :title="$route.meta.title"
      size="xl"
      v-model="sidebarToggle"
      :no-close-on-route-change="true"
      @hidden="$router.push({ name: 'contacts-show', params: { id: id } })"
      :lazy="true"
    >
      <router-view @contactUpdated="contactUpdated()"></router-view>
    </b-modal>
  </div>
</template>

<script>
import contactRepo from "@/api/repos/contactRepo";
import tableRow from "@/components/common/TableRow";
import fileUpload from "@/components/common/FileUpload";
import formGroup from "@/components/common/FormGroup";
import imageUpload from "@/components/common/ImageUpload";

export default {
  props: ["id"],

  components: {
    tableRow,
    fileUpload,
    formGroup,
    imageUpload,
  },

  mounted() {
    this.getContact();
  },

  data() {
    return {
      sidebarToggle: false,
      tabIndex: 0,
      loading: false,
      contact: {},
      selectedContactFiles: [],
      fileComponentKey: 1,
      fileUploading: false,
      FileLoading: false,
      selectedImage: null,
      selectedImages: [],
      imageComponentKey: 1,
      imageUploading: false,
      ImageLoading: false,
    };
  },

  methods: {
    async deleteContact(id) {
      this.isBusy = true;
      try {
        await contactRepo.delete(id);
        this.$router.push({ name: "contacts" });
      } catch (error) {
        this.$root.$bvToast.toast("Whoops", {
            title: "Something went wrong",
            autoHideDelay: 3000,
            variant: "danger",
          });
      } finally {
        this.isBusy = false;
      }
    },
    confirmDelete(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete the contact.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((confirm) => (confirm ? this.deleteContact(id) : false))
        .catch((error) => console.log(error));
    },
    async getContact() {
      try {
        this.loading = true;
        let { data } = await contactRepo.get(this.id);
        this.contact = data.contact;
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },

    async saveFiles() {
      if (this.fileUploading) {
        this.$root.$bvToast.toast("Files Uploading", {
          title: "Please wait for files to upload",
          autoHideDelay: 2000,
          variant: "warning",
        });
        return false;
      } else {
        try {
          await contactRepo.files(this.id, {
            contact_files: this.selectedContactFiles.split(","),
          });
          this.$root.$bvToast.toast("Uploaded", {
            title: "Uploaded",
            autoHideDelay: 3000,
            variant: "success",
          });
          this.selectedContactFiles = [];
          this.fileComponentKey++;

          this.tabIndex = 1;
          this.getContact();
        } catch (ex) {
          this.$root.$bvToast.toast("Whoops", {
            title: "Something went wrong",
            autoHideDelay: 3000,
            variant: "danger",
          });
        }
      }
    },
    contactUpdated() {
      this.$bvToast.toast("Contact Updated", {
        title: "Success",
        autoHideDelay: 3000,
        variant: "success",
      });
      this.sidebarToggle = false;
      this.getContact();
    },
    async deleteFile(id) {
      this.loading = true;
      try {
        await contactRepo.fileDelete(this.id, id);
        this.getContact();
        this.tabIndex = 1;
      } catch (error) {
        this.$root.$bvToast.toast("Whoops", {
          title: "Something went wrong",
          autoHideDelay: 3000,
          variant: "danger",
        });
      } finally {
        this.loading = false;
      }
    },
    fileDeleteConfirm(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete the file.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((confirm) => (confirm ? this.deleteFile(id) : false))
        .catch((error) => console.log(error));
    },

    async deleteImage(id, contactId) {
      this.loading = true;
      try {
        await contactRepo.imageDelete(contactId, id);
        await this.getContact();
        this.tabIndex = 2;
        this.selectedImage = null;
      } catch (error) {
        this.$root.$bvToast.toast("Whoops", {
          title: "Something went wrong",
          autoHideDelay: 3000,
          variant: "danger",
        });
      } finally {
        this.loading = false;
      }
    },
    imageDeleteConfirm(id, contactId) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete the image.", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "YES",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((confirm) => (confirm ? this.deleteImage(id, contactId) : false))
        .catch((error) => console.log(error));
    },
    async saveImages() {
      if (this.imageUploading) {
        this.$root.$bvToast.toast("Images Uploading", {
          title: "Please wait for files to upload",
          autoHideDelay: 2000,
          variant: "warning",
        });
        return false;
      } else {
        try {
          await contactRepo.images(this.id, {
            contact_images: this.selectedImages.split(","),
          });
          this.$root.$bvToast.toast("Uploaded", {
            title: "Uploaded",
            autoHideDelay: 3000,
            variant: "success",
          });
          this.selectedImages = [];
          this.imageComponentKey++;
          await this.getContact();
          this.tabIndex = 2;
        } catch (ex) {
          this.$root.$bvToast.toast("Whoops", {
            title: "Something went wrong",
            autoHideDelay: 3000,
            variant: "danger",
          });
        }
      }
    },
  },

  watch: {
    $route: {
      immediate: true,
      handler: function (newVal) {
        this.sidebarToggle = newVal.meta && newVal.meta.sidebarToggle;
      },
    },
  },
};
</script>
